// extracted by mini-css-extract-plugin
module.exports = {"twttr":"TwitterUser-module--twttr--30X_T"};